import { createFileRoute } from '@tanstack/react-router'

import { DepartmentsPage } from '@/features/user-management/DepartmentsPage'

export const Route = createFileRoute('/_authenticated/user-mgt/departments')({
  component: DepartmentsPage,
})
